export const PREVISAO_PECAS = () => '/previsao-pecas';
/** Um pedido de compra com a chegada de cada peça (previsao-pecas/at-02). */
export const PREVISAO_PECAS_PEDIDO = (pedidoId = ':pedidoId') => `/previsao-pecas/pedidos/${pedidoId}`;
